import React from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import _ from 'lodash';
import { connect } from 'react-redux';
import Header from '../components/Header';
import Footer from '../components/Footer';
import DataLoader from '../components/DataLoader';
import AlacrityTable from '../components/AlacrityTable';
import {
  TransactionStatuses, endOfMonth,
  last2years,
  lookup, startOfMonth,
} from '../helpers/constants';
import { AlacrityDropdown } from '../components/AlacrityDropdown';
import DateRangeFilter from '../components/DateRangeFilter';
import JsonApi from '../helpers/json_api.js';
import { changeTheme, logoutUser } from '../api/authenticationApi';
import { Navigation } from '../components/Navigation';
import { settingDarkTable } from '../helpers/translations/cssClassHelper';
import {
  clearLS, getLS, removeLS, setLS,
} from '../helpers/utils';

class Transaction extends AlacrityTable {
  constructor(props) {
    super(props);
    this.filters = { filter: { transaction_date: { gte: startOfMonth, lte: endOfMonth } } };

    this.state = {
      currentFilter: this.filters,
      options: [],
      changeTheme: null,
    };

    this.columns = [
      {
        path: 'transaction_id', title: 'ID', isKey: true, filter: { type: 'TextFilter' }, hidden: true,
      },
      {
        path: 'amount',
        dataType: 'money',
        currencyPath: 'currency',
        title: this.setText('amount'),
        className: 'hideComparatorFilter',
        filter: { type: 'NumberFilter', numberComparators: ['='], defaultValue: { comparator: '=' } },
      },
      {
        path: 'transaction_date', title: 'time', sort: true, dataType: 'date', width: '30%',
      },
      {
        path: 'partner.company_name', title: 'merchant', formatExtraData: 'company_name', dataFormat: 'company_name',
      },
      {
        path: 'campaign.name', title: 'service', formatExtraData: 'name', dataFormat: 'name',
      },
      { path: 'f_status', title: 'status' },
      { path: 'content_info', title: 'description' },
    ];

    this.fromDate = moment.utc(last2years).format('YYYY-MM-DD HH:mm:ss');
    this.toDate = moment.utc(moment).format('YYYY-MM-DD HH:mm:ss');
    this.msisdn = getLS('msisdn');
  }

  filterHandler(from, to, attribute) {
    const _this = this;
    const fromComparator = JsonApi.normlizeComparator('>=');
    const toComparator = JsonApi.normlizeComparator('<=');
    const fromValue = from;
    const toValue = to;
    const filterValue = {};
    filterValue[fromComparator] = fromValue;
    filterValue[toComparator] = toValue;
    const filterObj = {};
    filterObj[attribute] = filterValue;

    const staticFilters = this.state.currentFilter ? ({ ...this.state.currentFilter.filter }) : {};
    const newFilters = { ...staticFilters, ...filterObj };
    _this.setState({ currentFilter: newFilters });
  }

  onChangeHandler(val, attribute) {
    const _this = this;
    const filterObj = {};

    filterObj[attribute] = val;
    const staticFilters = this.state.currentFilter ? ({ ...this.state.currentFilter.filter }) : {};
    const newFilters = { ...staticFilters, ...filterObj };
    _this.setState({ currentFilter: newFilters });
  }

  render() {
    const { i18n, t, width } = this.props;
    let options = [];

    if (this.props.i18n?.language && this.props.i18n.language != 'undefined') {
      const x = lookup.filter((o, index) => {
        if (o.key === this.props.i18n.language) {
          options = lookup[index].value;
        }
      });
    } else {
      options = TransactionStatuses;
    }

    return (
      <>
        <Header mainLayout width={width} />
        <div className="container-fluid">
          <br />
          {width <= 600 && (
            <h5>
              <b>
                {t('transaction-history')}
                {' '}
                -
                {' '}
                {this.msisdn}
              </b>
            </h5>
          )}
          {width > 600 && (
            <h3>
              {t('transaction-history')}
              {' '}
              -
              {' '}
              {this.msisdn}
            </h3>
          )}
          {width <= 600 && (
            <p className="small">{t('list-of-transaction')}</p>
          )}
          {width > 600 && (
            <p>{t('list-of-transaction')}</p>
          )}
          <hr className="style1" />
          <br />
          <div className={width < 600 ? 'row form-group' : 'row form-group justify-content-md-left'}>
            <div className={width < 600 ? 'col-sm-3' : width === 600 ? 'col-sm-6 mr-1 pr-1' : 'col-sm-4 mr-1 pr-1'}>
              <div className="form-group">
                <div className={getLS('dark') == 'true' || this.state.changeTheme == 'true' ? 'filter text-filter form-control form-control-dark' : 'filter text-filter form-control'}>
                  {' '}
                  <DateRangeFilter
                    from={this.startDate}
                    to={this.endDate}
                    onDateRangeChange={this.filterHandler.bind(this)}
                    filterAttribute="transaction_date"
                    locale={this.props.i18n.language}

                  />
                </div>
              </div>
            </div>
            <div className={width < 600 ? 'col-sm-3' : width === 600 ? 'col-sm-4 ml-0 pl-0 mr-1 pr-1' : 'col-sm-4'}>
              <AlacrityDropdown
                t={t}
                iLang={this.props.i18n.language}
                options={options}
                title={t('dropdown.status')}
                onChange={this.onChangeHandler.bind(this)}
                filterAttribute="status"
              />
            </div>
          </div>
        </div>
        {/* Main table layout */}
        <div id="wrapper">
          <div id="main" className="container-fluid">
            <div>
              <DataLoader
                id="Transaction"
                apiUrl="/summary-transactions"
                columns={this.columns}
                apiParams={this.state.currentFilter}
                changeTheme={this.props.changeTheme}
              />
            </div>
          </div>
        </div>
        <Footer className="footer-position" />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  changeTheme: state.auth.changeTheme,
});

export default withTranslation('lang')(withRouter(connect(mapStateToProps, null)(Transaction)));

// export default withTranslation( "lang" )( withRouter( Transaction ) );
